interface DeleteModalProps {
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteModal = ({ onClose, onCancel, onConfirm }: DeleteModalProps) => (
  <>
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-semibold">Delete Time Block</h2>
      <button
        onClick={onClose}
        className="text-gray-500 hover:text-gray-700"
        aria-label="Close modal"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div className="space-y-4">
      <p className="text-gray-600">
        Are you sure you want to delete this time block? This action cannot be undone.
      </p>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
          aria-label="Cancel deletion"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md"
          aria-label="Confirm deletion"
        >
          Delete
        </button>
      </div>
    </div>
  </>
); 